(() => {
  const track = (name, data) => {
    try { window.Shopify?.analytics?.publish?.(name, data); } catch { /* Analytics must never block shopping. */ }
    // GA4 goes through the Google & YouTube app's gtag on this page: Chrome blocks gtag.js inside Shopify's custom pixel sandbox.
    try {
      const analyticsAllowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed;
      if (typeof window.gtag !== 'function' || typeof analyticsAllowed !== 'function' || !analyticsAllowed()) return;
      const params = {send_to: 'G-K2EBEZXWW1'};
      Object.entries(data || {}).forEach(([key, value]) => { params[key] = Array.isArray(value) ? value.join(',') : value; });
      window.gtag('event', name, params);
    } catch { /* Analytics must never block shopping. */ }
  };
  const currencyCode = () => window.Shopify?.currency?.active || 'USD';
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form?.querySelector?.('input[name="contact[subject]"][value="Revo ambassador application"]')) track('revo_ambassador_applied', {page: location.pathname + location.search});
  });
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const heroToggle = video => video.closest('.hero')?.querySelector('[data-hero-toggle]');
  // Phones refuse autoplay in Low Power Mode or data saver, so a refused start keeps the video and offers Play rather than removing it.
  const labelHero = video => {
    const toggle = heroToggle(video);
    if (toggle) { toggle.hidden = false; toggle.textContent = video.paused ? 'Play video' : 'Pause video'; }
  };
  document.querySelectorAll('.revo-hero-video').forEach(video => {
    video.addEventListener('play', () => labelHero(video));
    video.addEventListener('pause', () => labelHero(video));
  });
  const startHero = video => {
    const playback = video.play();
    if (playback?.catch) playback.catch(() => labelHero(video));
  };
  const syncHeroMotion = () => document.querySelectorAll('.revo-hero-video').forEach(video => {
    if (motionPreference.matches) { video.pause(); labelHero(video); }
    else if (video.dataset.userPaused !== 'true') startHero(video);
  });
  syncHeroMotion();
  motionPreference.addEventListener('change', syncHeroMotion);
  // Safari pauses the video when the page comes back from the back/forward cache or a background tab.
  window.addEventListener('pageshow', event => { if (event.persisted) syncHeroMotion(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') syncHeroMotion(); });
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-hero-toggle]');
    if (!toggle) return;
    const video = toggle.closest('.hero')?.querySelector('.revo-hero-video');
    if (!video) return;
    if (video.paused) { delete video.dataset.userPaused; startHero(video); }
    else { video.dataset.userPaused = 'true'; video.pause(); }
  });
  document.addEventListener('click', event => {
    const thumb = event.target.closest('[data-revo-16-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-revo-16-gallery]');
    const view = thumb.getAttribute('data-revo-16-thumb');
    gallery.querySelectorAll('[data-revo-16-slide]').forEach(slide => { slide.hidden = slide.getAttribute('data-revo-16-slide') !== view; });
    gallery.querySelectorAll('[data-revo-16-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
  });
  const updatePair = form => {
    const choices = [...form.querySelectorAll('[data-pair-choice]')];
    const available = choices.every(choice => choice && choice.dataset.available === 'true');
    const total = choices.reduce((sum, choice) => sum + Number(choice?.dataset.price || 0), 0);
    form.querySelector('[data-pair-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: window.Shopify?.currency?.active || 'USD'}).format(total / 100);
    const button = form.querySelector('button[type="submit"]');
    button.disabled = !available;
    button.textContent = available ? (form.dataset.addLabel || 'Add both to bag') : 'Pair unavailable';
  };
  document.addEventListener('click', event => {
    const variant = event.target.closest('[data-pair-variant]');
    if (!variant) return;
    const form = variant.closest('[data-pair-purchase]');
    const choice = form.querySelector(`[data-pair-choice][data-slot="${variant.dataset.slot}"]`);
    choice.value = variant.dataset.id;
    choice.dataset.price = variant.dataset.price;
    choice.dataset.available = variant.dataset.available;
    variant.parentElement.querySelectorAll('[data-pair-variant]').forEach(button => button.setAttribute('aria-pressed', String(button === variant)));
    updatePair(form);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest?.('[data-pair-purchase]');
    if (!form || location.protocol === 'file:') return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-pair-error]');
    const choices = [...form.querySelectorAll('[data-pair-choice]')];
    if (button.disabled || choices.some(choice => choice.dataset.available !== 'true')) return;
    error.hidden = true;
    button.disabled = true;
    button.textContent = 'Adding both…';
    try {
      const response = await fetch(`${form.action}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: choices.map(choice => ({id: Number(choice.value), quantity: 1}))})
      });
      if (!response.ok) {
        const result = await response.json().catch(() => null);
        throw new Error(result?.description || result?.message || 'Could not add this pair. Please try again.');
      }
      track('revo_pair_added', {pair: form.closest('.revo-pair')?.querySelector('h3')?.textContent.trim() || '', variant_ids: choices.map(choice => Number(choice.value)), value: choices.reduce((sum, choice) => sum + Number(choice.dataset.price || 0), 0) / 100, currency: currencyCode()});
      location.assign(form.dataset.cartUrl);
    } catch (cause) {
      error.textContent = cause.message || 'Could not add this pair. Please try again.';
      error.hidden = false;
      button.disabled = false;
      button.textContent = form.dataset.addLabel || 'Add both to bag';
    }
  });
  const selectScent = (section, id) => {
    const selected = [...section.querySelectorAll('[data-scent-select]')].find(button => button.dataset.scentSelect === id);
    if (selected) section.querySelector('.scent-display').style.setProperty('--scent-name', JSON.stringify(selected.dataset.scentName));
    if (selected?.dataset.scentBackground) section.querySelector('.scent-display').style.backgroundColor = selected.dataset.scentBackground;
    section.querySelectorAll('[data-scent-panel]').forEach(panel => { panel.hidden = panel.dataset.scentPanel !== id; });
    section.querySelectorAll('[data-scent-backdrop]').forEach(panel => { panel.hidden = panel.dataset.scentBackdrop !== id; });
    section.querySelectorAll('[data-scent-image]').forEach(panel => { panel.hidden = panel.dataset.scentImage !== id; });
    section.querySelectorAll('[data-scent-select]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.scentSelect === id)));
  };
  document.addEventListener('click', event => {
    const drawerButton = event.target.closest('[data-js-sidebar-handle]');
    if (drawerButton && !drawerButton.hasAttribute('onclick')) {
      const drawer = document.getElementById(drawerButton.getAttribute('aria-controls'));
      if (drawer?.show) { drawer.show(); drawerButton.setAttribute('aria-expanded', 'true'); }
    }
    const scent = event.target.closest('[data-scent-select]');
    if (scent) selectScent(scent.closest('[data-revo-scents]'), scent.dataset.scentSelect);
    const variant = event.target.closest('[data-card-variant]');
    if (variant) {
      const card = variant.closest('[data-revo-card]');
      card.querySelectorAll('[data-card-variant]').forEach(button => button.setAttribute('aria-pressed', String(button === variant)));
      card.querySelectorAll('[data-card-link]').forEach(link => { link.href = variant.dataset.url; });
      card.querySelector('[data-card-meta]').textContent = variant.dataset.cardTitle;
      card.querySelector('[data-card-price]').textContent = variant.dataset.price;
      card.querySelector('form [name="id"]').value = variant.dataset.cardVariant;
      const add = card.querySelector('form button[type="submit"]');
      add.disabled = variant.dataset.available !== 'true';
      add.querySelector('span').textContent = add.disabled ? 'Sold out' : 'Add to bag';
      const picture = card.querySelector('.product-art img');
      if (picture && variant.dataset.image) { picture.removeAttribute('srcset'); picture.src = variant.dataset.image; picture.alt = card.querySelector('.product-title').textContent.trim() + ' · ' + variant.dataset.cardTitle; }
    }
    const link = event.target.closest('[data-family-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || window.Shopify?.designMode) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    const group = link.closest('[data-family-options]');
    try {
      sessionStorage.setItem('revo-option-position', JSON.stringify({
        path: url.pathname + url.search,
        top: group.getBoundingClientRect().top,
        savedAt: Date.now()
      }));
    } catch { /* Native navigation remains available when browser storage is disabled. */ }
  });
  const restorePosition = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem('revo-option-position') || 'null');
      sessionStorage.removeItem('revo-option-position');
      if (!saved || saved.path !== location.pathname + location.search || Date.now() - saved.savedAt > 30000) return;
      const group = document.querySelector('[data-family-options]');
      if (!group) return;
      window.scrollBy({top: group.getBoundingClientRect().top - saved.top, behavior: 'instant'});
      group.querySelector('[aria-current="page"]')?.focus({preventScroll: true});
    } catch { /* A malformed or unavailable saved position must not interrupt the page. */ }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restorePosition, {once: true});
  else restorePosition();
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-scent-panel]');
    if (panel) selectScent(panel.closest('[data-revo-scents]'), panel.dataset.scentPanel);
  });
  const optionA = document.querySelector('[data-option-a-purchase]');
  if (optionA) {
    const form = optionA.querySelector('[data-option-a-form]');
    const quantity = form.querySelector('[data-option-a-quantity]');
    const button = form.querySelector('[data-option-a-submit]');
    const buttonText = form.querySelector('[data-option-a-submit-text]');
    const error = form.querySelector('[data-option-a-error]');
    const currency = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: window.Shopify?.currency?.active || 'USD'});
    const money = cents => currency.format(cents / 100);
    let pending = false;
    let selectedSizeOz = 128;
    let cartTotal = 0;
    let cartLoaded = false;
    let shippingWasBelow = false;
    let shippingReachedSent = false;
    const sizeButtons = [...optionA.querySelectorAll('[data-option-a-size-preview]')];
    const initialSize = sizeButtons.find(size => size.getAttribute('aria-pressed') === 'true');
    if (initialSize) selectedSizeOz = Number(initialSize.dataset.optionASizePreview);
    const homeGallery = document.querySelector('[data-revo-16-gallery]');
    const bathBand = document.querySelector('[data-option-a-baths]');
    const getQuantity = () => Number(quantity.value);
    const selectedAddons = () => [...form.querySelectorAll('[data-option-a-addon]:checked')];
    const updateOptionA = () => {
      const count = getQuantity();
      const valid = Number.isInteger(count) && count >= 1 && count <= 99;
      const addons = selectedAddons();
      const total = (valid ? count : 0) * Number(optionA.dataset.basePrice) + addons.reduce((sum, addon) => sum + Number(addon.dataset.price), 0);
      const items = (valid ? count : 0) + addons.length;
      button.disabled = pending || selectedSizeOz === 16 || !valid || button.dataset.available === 'false' || !form.querySelector('[data-option-a-main-id]').value;
      if (!pending) buttonText.textContent = selectedSizeOz === 16 ? '16 fl oz coming in November' : button.dataset.available === 'false' ? 'Sold out' : valid ? `Add ${items} ${items === 1 ? 'item' : 'items'} to bag · ${money(total)}` : 'Choose a quantity from 1 to 99';
      const unit = document.querySelector('[data-option-a-unit-price]');
      if (unit) unit.textContent = `${money(Number(optionA.dataset.basePrice) / Number(unit.dataset.volumeOz))} per fl oz`;
      const sizePrice = optionA.querySelector('[data-option-a-size-price]');
      if (sizePrice) sizePrice.textContent = money(Number(optionA.dataset.basePrice));
      const shipping = optionA.querySelector('[data-option-a-shipping]');
      if (shipping) {
        shipping.hidden = selectedSizeOz === 16;
        const threshold = Number(shipping.dataset.threshold);
        const reached = cartTotal + total;
        if (cartLoaded && !shipping.hidden && reached < threshold) shippingWasBelow = true;
        if (cartLoaded && !shipping.hidden && reached >= threshold && shippingWasBelow && !shippingReachedSent) {
          shippingReachedSent = true;
          track('revo_free_shipping_reached', {product_path: location.pathname, bag_value: cartTotal / 100, selection_value: total / 100, threshold: threshold / 100, currency: currencyCode()});
        }
        shipping.querySelector('[data-option-a-shipping-label]').textContent = reached >= threshold
          ? (cartTotal > 0 ? 'Your bag with this selection qualifies for free US shipping.' : 'This selection qualifies for free US shipping.')
          : `Add ${money(threshold - reached)} more for free US shipping.`;
        shipping.querySelector('[data-option-a-shipping-fill]').style.width = `${Math.min(100, Math.max(0, reached / threshold * 100))}%`;
      }
    };
    const updateSizePreview = () => {
      const previewing = selectedSizeOz === 16;
      sizeButtons.forEach(size => {
        const active = Number(size.dataset.optionASizePreview) === selectedSizeOz;
        size.classList.toggle('revo-option-a-size-card--active', active);
        size.setAttribute('aria-pressed', String(active));
      });
      const price = document.querySelector('.revo-option-a-price-line [data-update-block="price-compact"]');
      const unit = document.querySelector('[data-option-a-unit-price]');
      const previewPrice = document.querySelector('[data-option-a-preview-price]');
      if (price) price.hidden = previewing;
      if (unit) unit.hidden = previewing;
      if (previewPrice) previewPrice.hidden = !previewing;
      if (homeGallery) {
        const gallery = homeGallery.closest('[data-js-product-gallery]');
        const wasHome = gallery.classList.contains('revo-show-16');
        gallery.classList.toggle('revo-show-16', previewing);
        if (wasHome && !previewing) requestAnimationFrame(() => {
          const slider = gallery.querySelector('css-slider');
          if (slider?.sliderEnabled) slider.resetSlider();
          else window.dispatchEvent(new Event('resize'));
        });
      }
      if (bathBand) {
        bathBand.hidden = previewing;
        if (!previewing) {
          const readyOz = selectedSizeOz * (Number(bathBand.dataset.dilution) + 1);
          bathBand.querySelector('[data-option-a-bath-headline]').textContent = `A gallon makes ${readyOz} fl oz of mixed shampoo.`;
          bathBand.querySelectorAll('[data-option-a-bath-count]').forEach(count => {
            count.textContent = String(Math.floor(readyOz / Number(count.dataset.useOz)));
          });
        }
      }
      updateOptionA();
    };
    sizeButtons.forEach(size => size.addEventListener('click', () => {
      selectedSizeOz = Number(size.dataset.optionASizePreview);
      updateSizePreview();
    }));
    const routine = optionA.querySelector('[data-option-a-routine]');
    form.addEventListener('input', updateOptionA);
    form.addEventListener('change', event => {
      const toggled = event.target.closest('[data-option-a-addon]');
      if (toggled) track('revo_routine_addon_toggled', {product_path: location.pathname, addon_variant_id: Number(toggled.dataset.id), checked: toggled.checked, price: Number(toggled.dataset.price) / 100, currency: currencyCode()});
      const select = event.target.closest('[data-option-a-addon-variant]');
      if (select) {
        const row = select.closest('[data-option-a-row]');
        const choice = select.selectedOptions[0];
        const addon = row.querySelector('[data-option-a-addon]');
        addon.dataset.id = choice.value;
        addon.dataset.price = choice.dataset.price;
        row.querySelector('[data-option-a-addon-price]').textContent = `+ ${money(Number(choice.dataset.price))}`;
        const choiceKind = select.dataset.optionAChoiceKind || 'color';
        row.querySelector('[data-option-a-variant-label]').textContent = `Selected ${choiceKind}: ${choice.dataset.choiceLabel || choice.textContent.split(' · ')[0]}`;
        const image = row.querySelector('.revo-option-a-row-art img');
        if (image && choice.dataset.image) { image.src = choice.dataset.image; image.removeAttribute('srcset'); }
      }
      updateOptionA();
    });
    form.querySelector('[data-option-a-decrement]').addEventListener('click', () => {
      quantity.value = String(Math.max(1, getQuantity() - 1 || 1));
      updateOptionA();
    });
    form.querySelector('[data-option-a-increment]').addEventListener('click', () => {
      quantity.value = String(Math.min(99, getQuantity() + 1 || 1));
      updateOptionA();
    });
    const picker = document.querySelector('.revo-option-a [data-main-product-variants]');
    picker?.addEventListener('VARIANT_CHANGE', () => {
      const variantData = picker.querySelector('[data-js-variant-data]');
      if (!variantData) return;
      const variant = JSON.parse(variantData.textContent);
      if (!variant) {
        form.querySelector('[data-option-a-main-id]').value = '';
        button.dataset.available = 'false';
        updateOptionA();
        return;
      }
      form.querySelector('[data-option-a-main-id]').value = variant.id;
      optionA.dataset.basePrice = variant.price;
      button.dataset.available = String(variant.available);
      updateOptionA();
    });
    form.addEventListener('submit', async event => {
      if (location.protocol === 'file:') return;
      event.preventDefault();
      if (pending) return;
      const count = getQuantity();
      if (selectedSizeOz === 16 || !Number.isInteger(count) || count < 1 || count > 99 || button.dataset.available === 'false') { updateOptionA(); return; }
      const items = [{id: Number(form.querySelector('[data-option-a-main-id]').value), quantity: count}, ...selectedAddons().map(addon => ({id: Number(addon.dataset.id), quantity: 1}))];
      error.hidden = true;
      pending = true;
      button.disabled = true;
      buttonText.textContent = 'Adding to bag…';
      try {
        const response = await fetch(`${form.action}.js`, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items})});
        if (!response.ok) {
          const result = await response.json().catch(() => null);
          throw new Error(result?.description || result?.message || 'Could not add these items. Please try again.');
        }
        const addons = selectedAddons();
        if (addons.length) track('revo_routine_bundle_added', {product_path: location.pathname, quantity: count, addon_count: addons.length, addon_variant_ids: addons.map(addon => Number(addon.dataset.id)), value: (count * Number(optionA.dataset.basePrice) + addons.reduce((sum, addon) => sum + Number(addon.dataset.price), 0)) / 100, currency: currencyCode()});
        location.assign(optionA.dataset.cartUrl);
      } catch (cause) {
        error.textContent = cause instanceof TypeError ? 'Could not reach the bag. Please try again.' : cause.message || 'Could not add these items. Please try again.';
        error.hidden = false;
        pending = false;
        updateOptionA();
      }
    });
    window.addEventListener('pageshow', event => { if (event.persisted) { pending = false; updateOptionA(); } });
    if (location.protocol !== 'file:') {
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {credentials: 'same-origin'})
        .then(response => response.ok ? response.json() : null)
        .then(cart => { if (cart) { cartTotal = Number(cart.total_price) || 0; cartLoaded = true; updateOptionA(); } })
        .catch(() => {});
    }
    const reviewTarget = document.querySelector('[data-option-a-reviews]');
    const attachReviews = () => {
      const reviews = document.querySelector('#judgeme_product_reviews');
      if (!reviews || !reviewTarget) return false;
      const summary = reviews.querySelector('[data-average-rating][data-number-of-reviews]');
      const count = Number(summary?.dataset.numberOfReviews || 0);
      const section = reviewTarget.closest('.revo-option-a-reviews');
      if (reviews.hidden) reviews.hidden = false;
      if (reviews.parentElement !== reviewTarget) reviewTarget.append(reviews);
      if (section.hidden) section.hidden = false;
      // No reviews yet: keep Judge.me's "Be the first to write a review" button, and keep watching in case the count arrives late.
      const empty = count <= 0;
      if (section.classList.contains('revo-option-a-reviews--empty') !== empty) section.classList.toggle('revo-option-a-reviews--empty', empty);
      if (count <= 0) return false;
      if (document.querySelector('.revo-option-a-rating')) return true;
      const link = document.createElement('a');
      link.className = 'revo-option-a-rating';
      link.href = '#revo-reviews-heading';
      link.textContent = `★ ${Number(summary.dataset.averageRating).toFixed(1)} · ${count} ${count === 1 ? 'review' : 'reviews'}`;
      document.querySelector('.revo-option-a .product__title')?.after(link);
      return true;
    };
    if (!attachReviews() && reviewTarget) {
      const observer = new MutationObserver(() => { if (attachReviews()) observer.disconnect(); });
      observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-number-of-reviews']});
      window.setTimeout(() => observer.disconnect(), 10000);
    }
    updateSizePreview();
    routine.classList.add('is-ready');
  }
})();
